import { render, staticRenderFns } from "./BSAbsentModal.vue?vue&type=template&id=aa0b2e44"
import script from "./BSAbsentModal.vue?vue&type=script&lang=js"
export * from "./BSAbsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports